module.exports = __webpack_public_path__ + "img/Tertiary-chevron.b8abfde1.svg";